// Fork: troca "Chatwoot" pelo nome da instalação (INSTALLATION_NAME) em todos os textos
// da interface, sem editar os arquivos de tradução do upstream.
// \b evita tocar em identificadores como {latestChatwootVersion}; "chatwoot.com" não é afetado.
const BRAND_PATTERN = /\bChatwoot\b/g;

const replaceDeep = (value, name) => {
  if (typeof value === 'string') return value.replace(BRAND_PATTERN, name);
  if (Array.isArray(value)) return value.map(item => replaceDeep(item, name));
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, item]) => [key, replaceDeep(item, name)])
    );
  }
  return value;
};

export const brandMessages = (
  messages,
  name = window.globalConfig?.INSTALLATION_NAME
) => {
  if (!name || name === 'Chatwoot') return messages;
  return replaceDeep(messages, name);
};
